import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './funnelView.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { Funnel } from '../types/indes';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { ReactComponent as ArchiveFunnel } from '@/assets/steam/archive.svg';
import { ReactComponent as EditIcon } from '@/assets/steam/edit-white.svg';
import { ReactComponent as Statusicon } from '@/assets/steam/status-funnel.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-detail.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as Locationicon } from '@/assets/steam/grey-location.svg';
import { ReactComponent as Callicon } from '@/assets/steam/call.svg';
import { ReactComponent as Download } from '@/assets/steam/download-grey.svg';
import { ReactComponent as AudioIcon } from '@/assets/steam/audio.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import { ReactComponent as CalenderRed } from '@/assets/steam/calender-red.svg';
import { ReactComponent as CalenderGreen } from '@/assets/steam/calender-green.svg';
import { ReactComponent as InfoIcon } from '@/assets/steam/info-icon.svg';
import DeleteConfirmation from '@/components/DeleteConfirmation/DeleteConfirmation';
import InitialsAvatar from 'react-initials-avatar';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';

import { Button } from '@/components/Elements';
import HistoryDialog from '../historyComponent/historyDialog';
import { useGetHistory } from '../api/getHistory';
import QuotesDialog from '../historyComponent/quotesDialog';
import AudioPlayer from './audioPlayer';
const FunnelView: VFC<{
    selectedFunnel?: Funnel;
    onEditClick:()=>void;
    onClickArchiveFunnel:(data:any)=>void;
    isLoading: boolean;
    usersListData: any;
    productList:any;
}> = ({ selectedFunnel , onEditClick, onClickArchiveFunnel, isLoading, usersListData, productList}) => {
    const { user } = useAuth();

    const [showAddContactModal, setShowAddContactModal] = useState<boolean>(false);
    const [isOpenHistoryDialog, setIsopenHistoryDialog] = useState('');
    const [historyDetailss, setHistoryDetails] = useState<any>('')
    const useGetHistoryMutation = useGetHistory();

    const FUNNEL_TYPES = {
        BOOK_FUNNEL: '2',
        PRODUCT_FUNNEL: '1',
    };


    const getAssignedSubjects = (assignedSubjectIds: string[], product: any) => {
        if (product && product.subject && assignedSubjectIds && assignedSubjectIds.length > 0) {
            const assignedSubjects = product.subject.filter((sub: any) =>
                assignedSubjectIds.includes(sub.id)
            );

            const subjectNames = assignedSubjects.map((sub: any) => sub.name);

            const firstSubject = subjectNames.slice(0, 1);
            const remainingCount = subjectNames.length - 1;

            return {
                firstSubject ,
                remainingCount: remainingCount > 0 ? remainingCount : 0,
            };
        }

        return { firstSubject: [], remainingCount: 0 };
    };

    const getAssignedClasses = (assignedClassIds: string[], product: any) => {
        if (product && product.subject && assignedClassIds && assignedClassIds.length > 0) {
            const allClasses = product.subject.reduce((classes: any[], subject: any) => {
                return classes.concat(subject.classes);
            }, []);


            const assignedClasses = allClasses.filter((cls: any) =>
                assignedClassIds.includes(cls.id)
            );
            const classNames = assignedClasses.map((cls: any) => cls.name);

            const firstClass = classNames.slice(0, 1);
            const remainingClassCount = classNames.length - 1;

            return {
                firstClass,
                remainingClassCount: remainingClassCount > 0 ? remainingClassCount : 0,
            };
        }

        return { firstClass: [], remainingClassCount: 0 };
    };


    const getFunnelHistoryDetails = async(column:any, id:any)=>{
        const res = await useGetHistoryMutation.mutateAsync({
            id, column,instituteId: selectedFunnel?.institute?.id
        });

        if (res) {
            setHistoryDetails(res?.history)
        }
    }

    const onConfirm = () => {
        onClickArchiveFunnel(selectedFunnel?.id)
        setShowAddContactModal(false)
    }

    const onClose = () => {
        setShowAddContactModal(false)
    }


    return (
        <>

          {/* {isLoading && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )} */}
       {selectedFunnel ? <div className='funnel-view-container'>
            <div className='funnel-institute-details'>
                <div className='institute-name-details'>
                    <div className='institute-name'>
                        {selectedFunnel?.institute?.name}
                    </div>
                    <div className='assigned-user'> {selectedFunnel?.assignedUser?.name}
                        {"  "} <div className="horizontal-line"></div><div className={`funnels-bg ${FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnel?.type ? "change-bg" : ''}`}> {FUNNEL_TYPES.BOOK_FUNNEL !== selectedFunnel?.type ? <BookFunnelIcon className='book-funnel-icon' /> : <ProductFunnelicon className='book-funnel-icon' />}{FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnel?.type ? 'Books Funnel' : 'Platform Funnel'}</div>
                    </div>
                </div>
                {!selectedFunnel?.isArchived &&<div className='update-funnel-btn'>
                    <div className='update-btn'>
                        <button
                            className={`steam-button button-dark display-flex`}
                            onClick={()=>{onEditClick()}}
                        >
                            <EditIcon /><span>Edit Funnel</span>
                        </button>
                    </div>
                    <div className='archive-btn' onClick={()=>setShowAddContactModal(true)}>
                        <ArchiveFunnel />
                    </div>
                </div>}

            </div>

            <div className='divider mt-4'></div>

            <div className='funnel-followup mt-2'>
                <div className='details-panel'>
                    <Locationicon />
                    <div className='ddd-details'>
                        <div className='tags'>State and city</div>
                        <div className='s-c-detail'>
                            {selectedFunnel?.institute?.state?.name},  {selectedFunnel?.institute?.city?.name}
                        </div>
                    </div>
                </div>

                <div className='details-panel'>
                {Utils.getDateConfig(selectedFunnel?.followUpDate) === 'today' ? <CalenderGreen /> : Utils.getDateConfig(selectedFunnel?.followUpDate) === 'expired'? <CalenderRed/> : <Calendericon/>}
                    <div className='ddd-details'>
                        <div className='tags'>Follow up date{selectedFunnel &&  <InfoIcon onClick={()=>{setIsopenHistoryDialog('followUpDate'); getFunnelHistoryDetails('followUpDate', selectedFunnel.id)}}/>}</div>
                        <div className={`s-c-detail ${Utils.getDateConfig(selectedFunnel?.followUpDate) === 'today'  ? 'is-today' : '' } ${Utils.getDateConfig(selectedFunnel?.followUpDate) === 'expired'  ? 'is-expired' : '' }`}>
                            {selectedFunnel?.followUpDate ? Utils.formatDate(selectedFunnel?.followUpDate) : ''}
                        </div>
                    </div>
                </div>

                <div className='details-panel'>
                    <Statusicon />
                    <div className='ddd-details'>
                        {selectedFunnel &&<div className='tags'>Funnel state <InfoIcon onClick={()=>{setIsopenHistoryDialog('funnelState'); getFunnelHistoryDetails('stageId', selectedFunnel.id)}}/></div>}
                        <div className='s-c-detail'>
                            {selectedFunnel?.stage?.name}
                        </div>
                    </div>
                </div>

            </div>

            <div className='divider mt-4'></div>

            <div className='funnel-product-details mt-5'>
                <div className='pd-title mb-2'>
                    <div className='title'><ProductIcon />Product Details  {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length === 0 && <div>- Catapult</div>} {selectedFunnel &&<InfoIcon  onClick={()=>{setIsopenHistoryDialog('productDetails'); getFunnelHistoryDetails('productDetails', selectedFunnel.id)}}/>}</div>
                    <div className='size'>
                        Deal size <span>{Utils.convertDealSize(Number(selectedFunnel?.dealSize))}</span>
                    </div>
                </div>
               {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length > 0 && <div className='product-details-tab'>
                    <div className='product-header'>
                        <div className='name'>
                            Target Products
                        </div>
                        <div className='qty'>
                            Qty
                        </div>
                        <div className='sub'>
                            Subject
                        </div>
                        <div className='class'>
                            Class
                        </div>
                        <div className='price'>
                            Price
                        </div>

                    </div>

                    {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length > 0 && selectedFunnel?.productGroups.map((item: any, index: any) => {
                        const { firstSubject, remainingCount } = getAssignedSubjects(item.subject, item.product);
                        const { firstClass, remainingClassCount } = getAssignedClasses(item.class, item.product);
                        return (
                            <div className='product-values' key={index}>
                                <div className='name'>
                                    {item?.product?.name}
                                </div>
                                <div className='qty'>
                                    x{item.quantity}
                                </div>
                                <div className='sub'>
                                    <div className="table-contact  font-valeu">
                                        <div className='fix-width'>
                                            {firstSubject}
                                        </div>
                                        {remainingCount > 0 && (
                                            <span className='show-count'>
                                                +{remainingCount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className='class'>
                                    <div className="table-contact font-valeu">
                                        <div className='fix-width'>
                                            {firstClass}
                                        </div>
                                        {remainingCount > 0 && (
                                            <span className='show-count'>
                                                +{remainingClassCount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className='price'>
                                    {Utils.convertDealSize(Number(item?.price))}
                                </div>
                            </div>
                        )
                    })}




                </div>}

            </div>


            <div className='funnel-coverage-details mt-5'>
                <div className='cd-title mb-2'>
                    {selectedFunnel && <div className='coverage-title'><Coverageicon />Coverage Details <InfoIcon onClick={()=>{setIsopenHistoryDialog('coverageDetails'); getFunnelHistoryDetails('comments', selectedFunnel.id)}}/></div>}
                    <div className='coverage-type'>
                        <Callicon />In-Person coverage
                    </div>
                </div>
                <div className='divider mt-3'></div>

                <div className='lst-title'>
                Who did you meet/talk to?
                </div>
                <div className='contacts-div'>
                    {selectedFunnel?.institute?.contacts && selectedFunnel?.institute?.contacts.length > 0 && selectedFunnel?.institute?.contacts.map((item: any) => {
                        return (
                            <div className={`lst-details ${item?.isKeyPerson ? 'is-primary' : ''}`}>
                                <div className='user-left'>
                                    <InitialsAvatar name={item?.name ? item.name.charAt(0).toUpperCase() : 'SA'} className="avatar padding-coverage" />
                                    {item.name} {"  "} <div className="horizontal-line-1"></div><div className={`user-email`}> {item.email}</div> {item?.designation && <><div className="horizontal-line-1"></div><div className={`user-email`}> {item.designation}</div></>}
                                </div>
                                <div className='user-right'>
                                    <div className={`user-phone`}> {Utils.getPhone(item.phone)}</div>
                                </div>

                            </div>
                        )
                    })}



                </div>

                <div className='lst-title mt-4'>
                    Coverage Details
                </div>

                <div className='coverage-details-text mt-2'>
                    {selectedFunnel?.comments}

                </div>
             

                {selectedFunnel?.voiceLink && <div className='audio-file-container mt-4'>
                    <div className='audio-file-name'>
                        <AudioIcon />
                     
                        <div className='time'>
                            {/* <div>
                                Session_call_recording_31_dec.mp3
                            </div>
                            <div className='audio-mb'>
                                9.83 MB
                            </div> */}
                             
                        </div>
                    </div>
                    <div className='audio-unit'>
                        {selectedFunnel?.voiceLink ? <AudioPlayer isView={true} audioUrl={selectedFunnel?.voiceLink} removeFile={() => {  }} /> : ''}
                    </div>

                    {/* <div className='audio-file-options'>
                        <Download />
                    </div> */}

                </div>}

                <div className='lastcoverage-div mt-5'>
                    <div className='lastcoverage-title'>
                        <LastCoverageIcon /> Last date of coverage {selectedFunnel &&<InfoIcon onClick={()=>{setIsopenHistoryDialog('lastCoverageDate'); getFunnelHistoryDetails('coverageDate', selectedFunnel.id)}}/>}

                    </div>
                    <div className='last-coverage-date'>
                        {selectedFunnel?.coverageDate ? Utils.formatDate(selectedFunnel?.coverageDate) : ''}
                    </div >

                </div>

                <div className='divider mt-4'></div>
                <div className='lorem-text'>
                    {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. */}
                </div>


            </div>

        </div> : <div className='no-data-found width-full'>No Data!</div>}
        <DeleteConfirmation open={showAddContactModal} onClose={onClose} onConfirm={onConfirm} message='Are you sure you want to archive this funnel ?' subText='Archive Funnel' />

       {isOpenHistoryDialog && <HistoryDialog productList={productList} usersListData={usersListData} selectedFunnel = {selectedFunnel} funnetType={selectedFunnel?.type} historyDetailss={historyDetailss} open={isOpenHistoryDialog ? true : false} title={isOpenHistoryDialog} onClose={()=>{setIsopenHistoryDialog(''); setHistoryDetails('')}} onConfirm={()=>{setIsopenHistoryDialog(''); setHistoryDetails('')}}/>}
       
        </>
    );
};




export default FunnelView;
